//not used
;
define("taoQtiItem/qtiCreator/renderers/choices/InlineChoice", function(){});

